/* Sheepskinhouse.ch quantity ladder (Hyper theme).
   Cumulative: 2+ items = free shipping (Shopify automatic discount, not handled here)
   3+ items = + free brush, 4+ items = + free dryer balls, 5+ = 10 % (automatic discounts).
   Counts REAL items only: gift lines (property _free_gift), the gift variants themselves and the customs fee line
   (UpCharge app, property _mws_fee / product type mws_fee_generated) never count.
   SAFETY: a gift is only ever kept in the cart when Shopify really prices it at 0 – if the automatic discount is not
   active, the auto-added line is removed again and auto-add is switched off for the session (nobody pays for a "gift").
   After every cart mutation the cart is reconciled; UI is refreshed via Hyper's `cart:refresh` event. */
(function () {
  var GIFTS = (window.SSH_GIFTS || []).filter(function (g) { return g && g.variant && g.available !== false; });
  if (!GIFTS.length) return;
  var GIFT_VARIANTS = GIFTS.map(function (g) { return g.variant; });
  var PROP = '_free_gift';
  var busy = false, again = false;

  function isFee(it) {
    return !!(it.properties && Object.prototype.hasOwnProperty.call(it.properties, '_mws_fee')) || it.product_type === 'mws_fee_generated' || it.product_type === 'Fee';
  }
  function cartState(cart) {
    var giftLines = [], qty = 0, present = {};
    (cart.items || []).forEach(function (it) {
      if (isFee(it)) return;
      present[it.variant_id] = true;
      if (it.properties && it.properties[PROP]) { giftLines.push(it); return; }
      if (GIFT_VARIANTS.indexOf(it.variant_id) !== -1) return;
      qty += it.quantity;
    });
    return { giftLines: giftLines, qty: qty, present: present };
  }
  function getMap(k) { try { var m = JSON.parse(sessionStorage.getItem(k) || '{}'); return (m && typeof m === 'object') ? m : {}; } catch (e) { return {}; } }
  function setMap(k, m) { try { sessionStorage.setItem(k, JSON.stringify(m)); } catch (e) {} }
  function autoOff() { try { return sessionStorage.getItem('sshGiftOff') === '1'; } catch (e) { return false; } }

  function refreshUI() {
    try {
      if (/\/cart\/?$/.test(location.pathname)) { window.location.reload(); return; }
      var drawer = document.querySelector('cart-drawer');
      var open = !!(drawer && drawer.classList.contains('open')) || !!(drawer && drawer.hasAttribute('open'));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: open } }));
      fetch('/cart.js?ssh_gift=1').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      }).catch(function () {});
    } catch (e) { console.log('ssh-gift refreshUI', e); }
  }
  function mutate(url, payload) {
    return fetch(url + '?ssh_gift=1', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function finish() { busy = false; if (again) { again = false; setTimeout(reconcile, 120); } }

  /* remove auto-added gift lines that Shopify did not make free (discount missing/inactive) */
  function verifyFree() {
    return fetch('/cart.js?ssh_gift=1').then(function (r) { return r.json(); }).then(function (cart) {
      var st = cartState(cart), paid = st.giftLines.filter(function (gl) { return gl.final_line_price > 0; });
      if (!paid.length) return false;
      try { sessionStorage.setItem('sshGiftOff', '1'); } catch (e) {}
      var chain = Promise.resolve(null);
      paid.forEach(function (gl) { chain = chain.then(function () { return mutate('/cart/change.js', { id: gl.key, quantity: 0 }); }); });
      return chain.then(function () { return true; });
    }).catch(function () { return false; });
  }

  function reconcile() {
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js?ssh_gift=1').then(function (r) { return r.json(); }).then(function (cart) {
      var st = cartState(cart), added = getMap('sshGiftAdded'), dismissed = getMap('sshGiftDismissed');
      GIFTS.forEach(function (g) {
        var k = String(g.variant), earned = st.qty >= g.min;
        if (!earned) { delete dismissed[k]; delete added[k]; return; }
        if (added[k] && !st.present[g.variant]) dismissed[k] = 1;
      });
      var ops = [];
      st.giftLines.forEach(function (gl) {
        var gift = null;
        GIFTS.forEach(function (g) { if (g.variant === gl.variant_id) gift = g; });
        if (!gift || st.qty < gift.min) ops.push({ id: gl.key, quantity: 0 });
        else if (gl.quantity > 1) ops.push({ id: gl.key, quantity: 1 });
      });
      var adds = [];
      if (!autoOff()) GIFTS.forEach(function (g) { var k = String(g.variant); if (st.qty >= g.min && !st.present[g.variant] && !dismissed[k]) adds.push(g); });
      var chain = Promise.resolve(null);
      ops.forEach(function (op) { chain = chain.then(function () { return mutate('/cart/change.js', { id: op.id, quantity: op.quantity }); }); });
      adds.forEach(function (g) {
        chain = chain.then(function () {
          var props = {}; props[PROP] = '1';
          return mutate('/cart/add.js', { id: g.variant, quantity: 1, properties: props }).then(function (json) { if (json) added[String(g.variant)] = 1; return json; });
        });
      });
      chain.then(function () { return adds.length ? verifyFree() : false; }).then(function () {
        setMap('sshGiftAdded', added); setMap('sshGiftDismissed', dismissed);
        if (ops.length || adds.length) refreshUI();
        finish();
      }).catch(finish);
    }).catch(finish);
  }

  var CART_MUTATION = /\/cart\/(add|change|update|clear)/;
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    try { if (CART_MUTATION.test(url) && url.indexOf('ssh_gift=1') === -1) p.then(function () { setTimeout(reconcile, 150); }, function () {}); } catch (e) {}
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) { this.__sshUrl = url; return origOpen.apply(this, arguments); };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    try { var u = this.__sshUrl || ''; if (CART_MUTATION.test(u) && u.indexOf('ssh_gift=1') === -1) this.addEventListener('load', function () { setTimeout(reconcile, 150); }); } catch (e) {}
    return origSend.apply(this, arguments);
  };
  /* "add" buttons rendered by ssh-incentive (cart context): add the unlocked gift as a gift line */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.ssh-quickadd') : null;
    if (!b) return;
    e.preventDefault();
    var v = parseInt(b.getAttribute('data-variant') || '', 10);
    if (!v || b.classList.contains('is-busy')) return;
    b.classList.add('is-busy');
    var props = {}; props[PROP] = '1';
    var dismissed = getMap('sshGiftDismissed'); delete dismissed[String(v)]; setMap('sshGiftDismissed', dismissed);
    mutate('/cart/add.js', { id: v, quantity: 1, properties: props }).then(function (json) {
      return json ? verifyFree() : false;
    }).then(function () { b.classList.remove('is-busy'); refreshUI(); setTimeout(reconcile, 200); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(reconcile, 300); });
  else setTimeout(reconcile, 300);
})();
